import { useEffect } from 'react';

import './toast.css';

/** 自动消失的时间。到账这种事要让人来得及看清。 */
const HOLD_MS = 6000;

/**
 * 一条飘在界面上的通知。**在本页里**，不是系统通知、不是弹窗。
 *
 * 它现在只有一个用处：支付到账了要有人说一声 —— 而用户那时可能在任何一个
 * 标签页里，甚至在游戏里。所以它挂在 App 最外层，盖在所有东西上面。
 */
export function Toast(
  { message, kind = 'ok', onClose }:
  { message: string; kind?: 'ok' | 'warn'; onClose(): void },
) {
  useEffect(() => {
    const id = setTimeout(onClose, HOLD_MS);
    return () => clearTimeout(id);
  }, [message, onClose]);

  return (
    // role=status：读屏会念出来，而且**不会抢焦点** ——
    // 用户可能正在银行 App 切回来的路上，别打断他。
    <div className={`toast toast--${kind}`} role="status" onClick={onClose}>
      {message}
    </div>
  );
}
